import api from './api';

const addressBookUrl = process.env.REACT_APP_ADDRESSBOOK_API_URL;
const allContactsByCustomerBkUrl = `${addressBookUrl}/AddressBook/AllContactsByCustomerBk`;

/**
 * Searches email addresses from GTZ & Outlook
 * off a search term
 * @param {string} searchParams - Term to search
 * @return {object} - Response from network.
 */
const allContactsByCustomerBk = async (searchParams) => {
  const options = {
    url: allContactsByCustomerBkUrl,
    params: searchParams,
  };
  return api.get(options);
};

export default allContactsByCustomerBk;
